import { isPending } from './utils';
const sortByTimestamp = (a, b) => a.timestamp > b.timestamp ? -1 : 1;
export const getState = state => state.transaction;
export const getData = state => getState(state).data;
export const getLoading = state => getState(state).loading;
export const getTransaction = (state, hash) => getData(state).find(tx => tx.hash === hash);
export const getTransactionsByStatus = (state, address, status) => getData(state)
    .filter(tx => tx.from === address && tx.status === status)
    .sort(sortByTimestamp);
export const getTransactions = (state, address) => getData(state)
    .filter(tx => tx.from === address)
    .sort(sortByTimestamp);
export const getPendingTransactions = (state, address) => getData(state)
    .filter(tx => tx.from === address && isPending(tx.status))
    .sort(sortByTimestamp);
export const getTransactionHistory = (state, address) => getData(state)
    .filter(tx => tx.from === address && !isPending(tx.status))
    .sort(sortByTimestamp);
export const getTransactionsByType = (state, address, type) => getData(state)
    .filter(tx => tx.from === address && tx.actionType === type)
    .sort(sortByTimestamp);
//# sourceMappingURL=selectors.js.map